if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded);

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('quantity-popover__info-button--open');

          this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
              this.closePopover(e);
            }
          });
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}

/* Crafted Zone cart countdown — draft theme only */
(() => {
  const DURATION_MS = 10 * 60 * 1000;
  const STORAGE_KEY = 'cz-cart-countdown-end-v1';
  const STYLE_ID = 'cz-cart-countdown-styles';

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .cz-cart-message.cz-cart-timer {
        display: block !important;
        margin: 20px 0 26px !important;
        padding: 14px 18px !important;
        border: 0 !important;
        border-radius: 14px !important;
        background: #fff7e6 !important;
        color: #171717 !important;
        font-family: var(--font-body-family), Arial, sans-serif !important;
        box-shadow: none !important;
      }

      .cz-cart-message.cz-cart-timer .cz-cart-timer-line {
        display: block !important;
        margin: 0 !important;
        color: #171717 !important;
        font-size: 15px !important;
        line-height: 1.42 !important;
        font-weight: 500 !important;
        letter-spacing: 0 !important;
      }

      .cz-cart-message.cz-cart-timer .cz-cart-timer-line + .cz-cart-timer-line {
        margin-top: 1px !important;
      }

      .cz-cart-message.cz-cart-timer .cz-cart-timer-value {
        display: inline !important;
        color: #df2828 !important;
        font: inherit !important;
        font-weight: 750 !important;
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
      }

      @media screen and (max-width: 749px) {
        .cz-cart-message.cz-cart-timer {
          margin: 16px 0 7px !important;
          padding: 13px 15px !important;
          border-radius: 12px !important;
        }

        .cz-cart-message.cz-cart-timer .cz-cart-timer-line {
          font-size: 14px !important;
          line-height: 1.43 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getEndTime = () => {
    const now = Date.now();
    let storedEnd = 0;

    try {
      storedEnd = Number(sessionStorage.getItem(STORAGE_KEY)) || 0;
    } catch (error) {
      storedEnd = window.__czCartCountdownEnd || 0;
    }

    if (storedEnd <= now) {
      storedEnd = now + DURATION_MS;
      window.__czCartCountdownEnd = storedEnd;

      try {
        sessionStorage.setItem(STORAGE_KEY, String(storedEnd));
      } catch (error) {
        // The in-memory fallback above keeps the countdown functional.
      }
    }

    return storedEnd;
  };

  const endTime = getEndTime();

  const prepareMessage = (message) => {
    if (message.dataset.czTimerReady === 'true') return;

    message.dataset.czTimerReady = 'true';
    message.classList.add('cz-cart-timer');
    message.setAttribute('role', 'note');
    message.setAttribute('aria-live', 'off');
    message.innerHTML = `
      <div class="cz-cart-timer-line">
        Votre panier expirera dans <span class="cz-cart-timer-value" data-cz-cart-countdown>10:00</span> minutes !
      </div>
      <div class="cz-cart-timer-line">
        Finalisez votre commande avant que vos articles ne soient épuisés 🔥
      </div>
    `;
  };

  const renderCountdown = () => {
    ensureStyles();

    const message = document.querySelector('.cz-cart-message');
    if (!message) return;

    prepareMessage(message);

    const countdown = message.querySelector('[data-cz-cart-countdown]');
    if (!countdown) return;

    const remainingMs = Math.max(0, endTime - Date.now());
    const totalSeconds = Math.ceil(remainingMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    countdown.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  renderCountdown();

  if (!window.__czCartCountdownInterval) {
    window.__czCartCountdownInterval = window.setInterval(renderCountdown, 1000);
  }

  document.addEventListener('shopify:section:load', renderCountdown);
})();

/* Hide personalization details from the cart display while retaining them in the cart/order data. */
(() => {
  let filterTimeout;
  let filterInProgress = false;

  const normalizeText = (value) => String(value ?? '').replace(/\s+/g, ' ').trim();

  const filterPersonalizationDetails = async () => {
    if (filterInProgress) return;
    filterInProgress = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      const cart = await response.json();
      const itemRows = document.querySelectorAll('#main-cart-items .cart-item');

      itemRows.forEach((row, index) => {
        const properties = cart.items?.[index]?.properties || {};
        const visiblePropertyKeys = new Set(
          Object.keys(properties)
            .filter((key) => key && !key.startsWith('_') && properties[key] !== null && properties[key] !== '')
            .map(normalizeText)
        );

        if (visiblePropertyKeys.size === 0) return;

        row.querySelectorAll('.cz-options .cz-option').forEach((optionRow) => {
          const labelElement = optionRow.querySelector('dt');
          if (!labelElement) return;

          const label = normalizeText(labelElement.textContent).replace(/:$/, '').trim();
          if (visiblePropertyKeys.has(label)) {
            optionRow.remove();
          }
        });

        const optionsList = row.querySelector('.cz-options');
        if (optionsList && !optionsList.querySelector('.cz-option')) {
          optionsList.remove();
        }
      });
    } catch (error) {
      // Leave the cart functional if the cart JSON cannot be read temporarily.
    } finally {
      filterInProgress = false;
    }
  };

  const scheduleFilter = () => {
    window.clearTimeout(filterTimeout);
    filterTimeout = window.setTimeout(filterPersonalizationDetails, 40);
  };

  scheduleFilter();
  document.addEventListener('shopify:section:load', scheduleFilter);

  const cartItems = document.getElementById('main-cart-items');
  if (cartItems) {
    const observer = new MutationObserver(scheduleFilter);
    observer.observe(cartItems, { childList: true, subtree: true });
  }
})();
